import { Link } from '@reach/router';
import Image from 'js/components/pages/MyItemsPage/ItemsList/Item/Image';
import { formatCurrency } from 'js/services/Format';
import React from 'react';
import { url } from 'js/services/Network';
import CopyItemLink from 'js/new/Components/App/Item/CopyItemLink';

const ItemTable = ({
  items
}) => {
  const [origin, setOrigin] = React.useState('');

  React.useEffect(() => {
    setOrigin(window.location.origin);
  }, []);

  const headers = [
    'Item',
    'Item name',
    'Price (N)',
    'Quantity available',
    'Item link',
    'More'
  ]

  const Item = ({ item }) => {
    const link = url('manage-item-page', item)
    const itemLink = origin + url('checkout-page', item)

    return (
      <tr>
        <td>
          <Image src={item.image} />
        </td>
        <td>{item.title}</td>
        <td>{formatCurrency(item.price)}</td>
        <td>{item.quantity}</td>
        <td className='tw-flex gap-3 tw-items-center'>
          <Link to={link}><p className='tw-text-secondary tw-truncate' style={{maxWidth: '200px', marginBottom: '0px'}}>{itemLink}</p></Link>
          <CopyItemLink link={itemLink} />
        </td>
        <td>
          <Link to={link} >
            <p className='tw-text-secondary' style={{marginBottom: '0px'}}>view</p>
          </Link>
        </td>
      </tr>
    )
  }

  return (
    <div className="tw-overflow-x-auto">
      <table className="tw-table tw-table-auto tw-w-full">
        <thead>
          <tr>
            {headers.map((head, i) => (
              <th
                key={i}
                className={`${i === 0
                  ? 'tw-rounded-l-xl'
                  : i === headers.length - 1
                    ? 'tw-rounded-r-xl'
                    : ''
                  }`}
              >
                {head}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {items.map((item, i) => <Item key={i} item={item} />)}
        </tbody>
      </table>
    </div>
  )
}

export default ItemTable
